import EnquiryCreate from '@/components/enquiry/enquiry-create';

const routes = [
    {
        path: '/enquiry',
        name: 'enquiry',
        component: EnquiryCreate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Enquiry' }
            ]
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/enquiry/routes/index.js